export default "__VITE_ASSET__F9MCnUL___"